import { render, staticRenderFns } from "./history.vue?vue&type=template&id=55c2a92e&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=55c2a92e&prod&scoped=true&lang=css"
import style1 from "./history.vue?vue&type=style&index=1&id=55c2a92e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c2a92e",
  null
  
)

export default component.exports